export function oggi() {
    let today = new Date();
    let mese = (today.getMonth() + 1);
    if (mese < 10) {
        mese = '0' + mese;
    }
    let oggi = today.getDate()
    if (oggi < 10) {
        oggi = '0' + oggi;
    }
    return (today.getFullYear() + '-' + mese + '-' + oggi);
    //return date;
}

export function ieri() {
    let today = new Date();

    today.setDate(today.getDate() - 1);
    let mese = (today.getMonth() + 1);
    if (mese < 10) {
        mese = '0' + mese;
    }
    let oggi = today.getDate()
    if (oggi < 10) {
        oggi = '0' + oggi;
    }
    let date = today.getFullYear() + '-' + mese + '-' + oggi;
    return date;
    //return date;
}

export function ultsett() {
    let today = new Date();

    today.setDate(today.getDate() - 6);
    let mese = (today.getMonth() + 1);
    if (mese < 10) {
        mese = '0' + mese;
    }
    let oggi = today.getDate()
    if (oggi < 10) {
        oggi = '0' + oggi;
    }
    let date = today.getFullYear() + '-' + mese + '-' + oggi;
    return date;
    //return date;
}

export function ultmes() {
    let today = new Date();

    today.setMonth(today.getMonth() - 1);
    today.setDate(today.getDate() + 1);
    let mese = (today.getMonth() + 1);
    if (mese < 10) {
        mese = '0' + mese;
    }
    let oggi = today.getDate()
    if (oggi < 10) {
        oggi = '0' + oggi;
    }
    let date = today.getFullYear() + '-' + mese + '-' + oggi;
    return date;
    //return date;
}

export function ultann() {
    let today = new Date();

    today.setFullYear(today.getFullYear() - 1);
    today.setDate(today.getDate() + 1);
    let mese = (today.getMonth() + 1);
    if (mese < 10) {
        mese = '0' + mese;
    }
    let oggi = today.getDate()
    if (oggi < 10) {
        oggi = '0' + oggi;
    }
    let date = today.getFullYear() + '-' + mese + '-' + oggi;
    return date;
    //return date;
}

export function iniann() {
    let today = new Date();


    let mese = (today.getMonth() + 1);
    if (mese < 10) {
        mese = '0' + mese;
    }
    let date = today.getFullYear() + '-01-01';
    return date;
    //return date;
}
